module.exports = __webpack_public_path__ + "static/media/bg8.6823a2bc.png";